import { faBadgePercent } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, HookFormTextInput } from '@realtyka/real-ui';
import { Control, FieldErrors, useWatch } from 'react-hook-form';

export interface PromoCodeFormData {
  promoCode: string;
}

interface PromoCodeSectionProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  onApplyPromoCode: (code: string) => void;
  onRemovePromoCode: () => void;
  isSubmitting: boolean;
  appliedPromoCode?: string;
  promoDiscount?: number;
  errorMessage?: string;
  isInvitationDiscount?: boolean;
}

const PromoCodeSection: React.FC<PromoCodeSectionProps> = ({
  control,
  errors,
  onApplyPromoCode,
  onRemovePromoCode,
  isSubmitting,
  appliedPromoCode,
  promoDiscount,
  errorMessage,
  isInvitationDiscount = false,
}) => {
  const promoCodeValue = useWatch({
    control,
    name: 'promoCode',
  });

  const handleApply = () => {
    if (promoCodeValue && promoCodeValue.trim()) {
      onApplyPromoCode(promoCodeValue.trim());
    }
  };

  if (appliedPromoCode && promoDiscount !== undefined) {
    if (isInvitationDiscount) {
      return (
        <div className='flex items-center gap-2 text-real-green-600 text-sm font-inter'>
          <FontAwesomeIcon icon={faBadgePercent} className='w-4 h-4' />
          <span>Application Fees Waived</span>
        </div>
      );
    }

    return (
      <button
        onClick={onRemovePromoCode}
        className='flex items-center gap-2 text-real-blue-500 hover:text-real-blue-600 transition-colors text-sm font-inter'
        type='button'
      >
        <FontAwesomeIcon icon={faBadgePercent} className='w-4 h-4' />
        <span>Remove Promo Code</span>
      </button>
    );
  }

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex gap-2 items-end'>
        <div className='flex-1'>
          <HookFormTextInput<PromoCodeFormData, 'promoCode'>
            name='promoCode'
            control={control}
            label='Promo Code'
            placeholder='Enter promo code'
            disabled={isSubmitting}
            error={(errors.promoCode?.message as string) || errorMessage}
            icon={faBadgePercent}
          />
        </div>
        <Button
          onClick={handleApply}
          disabled={isSubmitting}
          loading={isSubmitting}
          variant='filled'
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default PromoCodeSection;
